import { type BuildEnvironment } from './build-environment';

// 🔥 REMEMBER TO REVERT BEFORE CHECKING IN 🔥

/** For PROD debugging switch to `true`
 **  - enables ngrx-store & blaze devtools
 **  - disables sources minification
 */
const ENABLE_PROD_OVERRIDE = false;

/** Add a name of subdomain if you need to develop code where subdomain must be properly set.
 *   Example: 'e2e.blaze.tech'
 **  - 'e2e.blaze.tech'                 - single environment
 **  - 'e2ecustom--staging.blaze.tech'  - multi-environment
 *   Custom domain examples:
 **  - 'app.triviatycoon.com'           - ben.blaze.tech
 **  - 'appbl.joinkiaora.com'           - kiaora.blaze.tech
 **  - 'portal.rxcompoundstore.com'     - rxcompoundstore.blaze.tech
 **  - 'www.orensteinapp.com'           - safewave.blaze.tech
 */
const DEV_SUBDOMAIN_OVERRIDE = '';

export const BASE_ENVIRONMENT: BuildEnvironment = {
  deploymentTarget: 'local',
  apiUrl: '',
  mediaCdnUrl: '',
  websocketsUrl: '',
  schemaValidation: false,
  prodDebugOverride: ENABLE_PROD_OVERRIDE,
  subdomainOverride: DEV_SUBDOMAIN_OVERRIDE.replaceAll('https://', ''),
};
